import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Analytics hook pro tracking pageview
 * Podporuje Google Analytics a Plausible
 */
export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Guard pro SSR/build
    if (typeof window === 'undefined') return;

    const path = location.pathname + location.search;

    // Google Analytics (gtag)
    if (window.gtag && process.env.REACT_APP_GA_ID) {
      window.gtag('config', process.env.REACT_APP_GA_ID, {
        page_path: path,
      });
    }

    // Plausible Analytics
    if (window.plausible && process.env.REACT_APP_PLAUSIBLE_DOMAIN) {
      window.plausible('pageview', {
        url: path,
      });
    }

    // Fallback: PostHog (pokud je již načten)
    if (window.posthog) {
      window.posthog.capture('$pageview', {
        $current_url: window.location.href,
      });
    }
  }, [location]);
};

